import React, { useEffect, useState, useCallback } from 'react'
import qrcode from 'qrcode'
import { useTranslations } from 'next-intl'
import { GetStaticProps } from 'next'

import { download } from '../utils/blob'
import QRCodeDoc from '../docs/qrcode.mdx'
import Header from '../components/layouts/header'
import { Seo } from '@/components/seo'

function QRCodePage() {
  const [value, setValue] = useState('hello, world')
  const t = useTranslations('QRCode')

  useEffect(() => {
    qrcode.toCanvas(document.getElementById('canvas'), value || ' ', {
      width: 250,
      margin: 2,
      color: {
        dark: '#333333cc',
        light: '#fefefefe'
      }
    })
  }, [value])

  const handleSave = useCallback(() => {
    const canvas = document.getElementById('canvas') as HTMLCanvasElement
    canvas.toBlob((blob) => {
      download(blob || '', t('downloadFileName'))
    })
  }, [t])

  return (
    <div className="container">
      <Seo
        title={t('pageTitle')}
        description={t('metaDescription')}
        path="/qrcode"
        thumbnail="https://devtool.tech/thumbnail/qrcode.png"
      />
      <Header title={t('headerTitle')} />
      <div className="grid grid-cols-1 font-mono text-lg rounded md:grid-cols-2 lg:grid-cols-3">
        <div className="h-80 lg:col-span-2">
          <textarea
            className="h-full app-input"
            autoFocus
            spellCheck={false}
            placeholder={t('inputPlaceholder')}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
        <div className="flex flex-col items-center break-words whitespace-pre-wrap h-80">
          <canvas id="canvas" className="border"></canvas>
          <button className="mt-6 mb-3 text-base app-button" onClick={handleSave}>
            {t('downloadButton')}
          </button>
        </div>
      </div>
      <QRCodeDoc />
    </div> 
  )
}

export default QRCodePage

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../messages/${locale}.json`)).default
    }
  }
}
